import { QEncode } from "../utils/QEncode";

export class QXMLObject {
  constructor() {
    this.fXMLElementName = null;
  }

  SetXMLElementName(elementName) {
    this.fXMLElementName = elementName;
  }

  GetXMLElementName() {
    return this.fXMLElementName;
  }

  OutputElementHead(stream, elementName) {
    var openElement = this.BracketString(elementName, true);
    stream.Write(openElement);
  }

  OutputElementTail(stream, elementName) {
    var closeElement = this.BracketString(elementName, false);
    stream.Write(closeElement);
  }

  OutputVElement(elementValue, stream) {
    var ee = QEncode(elementValue);
    stream.Write("!" + ee);
  }

  OutputSimpleElementF(elementName, elementValue, stream) {
    var s = "<" + elementName + ">" + elementValue + "</" + elementName + ">";
    stream.Write(s);
  }

  OutputSimpleElement(elementName, elementValue, stream) {
    var openElement = this.BracketString(elementName, true);
    var closeElement = this.BracketString(elementName, false);

    var ee = QEncode(elementValue);
    stream.Write(openElement + ee + closeElement);
  }

  OutputElementPairF(elementName, elementValue1, elementValue2, stream) {
    var s =
      "<" + elementName + ">" + elementValue1 + "," + elementValue2 + "</" + elementName + ">";
    stream.Write(s);
  }

  OutputElementPair(elementName, elementValue1, elementValue2, stream) {
    var openElement = this.BracketString(elementName, true);
    var closeElement = this.BracketString(elementName, false);

    var ee1 = QEncode(elementValue1);
    var ee2 = QEncode(elementValue2);

    stream.Write(openElement + ee1 + "," + ee2 + closeElement);
  }

  OutputElementTriple(elementName, elementValue1, elementValue2, elementValue3, stream) {
    var openElement = this.BracketString(elementName, true);
    var closeElement = this.BracketString(elementName, false);

    var ee1 = QEncode(elementValue1);
    var ee2 = QEncode(elementValue2);
    var ee3 = QEncode(elementValue3);

    stream.Write(openElement + ee1 + "," + ee2 + "," + ee3 + closeElement);
  }

  OutputElementQuad(
    elementName,
    elementValue1,
    elementValue2,
    elementValue3,
    elementValue4,
    stream
  ) {
    var openElement = this.BracketString(elementName, true);
    var closeElement = this.BracketString(elementName, false);

    var ee1 = QEncode(elementValue1);
    var ee2 = QEncode(elementValue2);
    var ee3 = QEncode(elementValue3);
    var ee4 = QEncode(elementValue4);

    stream.Write(openElement + ee1 + "," + ee2 + "," + ee3 + "," + ee4 + closeElement);
  }

  OutputElementQuin(
    elementName,
    elementValue1,
    elementValue2,
    elementValue3,
    elementValue4,
    elementValue5,
    stream
  ) {
    var openElement = this.BracketString(elementName, true);
    var closeElement = this.BracketString(elementName, false);

    var ee1 = QEncode(elementValue1);
    var ee2 = QEncode(elementValue2);
    var ee3 = QEncode(elementValue3);
    var ee4 = QEncode(elementValue4);
    var ee5 = QEncode(elementValue5);

    stream.Write(openElement + ee1 + "," + ee2 + "," + ee3 + "," + ee4 + "," + ee5 + closeElement);
  }

  OutputElementSex(
    elementName,
    elementValue1,
    elementValue2,
    elementValue3,
    elementValue4,
    elementValue5,
    elementValue6,
    stream
  ) {
    var openElement = this.BracketString(elementName, true);
    var closeElement = this.BracketString(elementName, false);

    var ee1 = QEncode(elementValue1);
    var ee2 = QEncode(elementValue2);
    var ee3 = QEncode(elementValue3);
    var ee4 = QEncode(elementValue4);
    var ee5 = QEncode(elementValue5);
    var ee6 = QEncode(elementValue6);

    stream.Write(
      openElement + ee1 + "," + ee2 + "," + ee3 + "," + ee4 + "," + ee5 + "," + ee6 + closeElement
    );
  }

  OutputElementSept(
    elementName,
    elementValue1,
    elementValue2,
    elementValue3,
    elementValue4,
    elementValue5,
    elementValue6,
    elementValue7,
    stream
  ) {
    var openElement = this.BracketString(elementName, true);
    var closeElement = this.BracketString(elementName, false);

    var ee1 = QEncode(elementValue1);
    var ee2 = QEncode(elementValue2);
    var ee3 = QEncode(elementValue3);
    var ee4 = QEncode(elementValue4);
    var ee5 = QEncode(elementValue5);
    var ee6 = QEncode(elementValue6);
    var ee7 = QEncode(elementValue7);

    stream.Write(
      openElement +
        ee1 +
        "," +
        ee2 +
        "," +
        ee3 +
        "," +
        ee4 +
        "," +
        ee5 +
        "," +
        ee6 +
        "," +
        ee7 +
        closeElement
    );
  }

  OutputElementList(elementName, elementList, stream) {
    var outStr = this.BracketString(elementName, true);
    var n = elementList.length;
    for (var i = 0; i < n; i++) {
      var element = elementList[i];
      var ee = QEncode(element);
      if (i != n - 1) ee = ee + ",";
      outStr = outStr + ee;
    }

    outStr += this.BracketString(elementName, false);
    stream.Write(outStr);
  }

  BracketString(theName, openTag) {
    var outStr = "<";
    if (openTag == false) outStr = "</";
    outStr += QEncode(theName);
    outStr += ">";

    return outStr;
  }

  //=================================================================================================
  // Output Methods
  OutputSubElements(stream) {
    // Override this
  }

  OutputChildElements(stream) {
    // Override this
  }

  OutputToXML(stream) {
    var elementName = this.GetXMLElementName();
    this.OutputElementHead(stream, elementName);
    this.OutputSubElements(stream);
    this.OutputChildElements(stream);
    this.OutputElementTail(stream, elementName);
  }

  //=================================================================================================
  // Load Methods
  LoadParameters(objTree) {
    // Override this
  }

  LoadSubElements(objTree) {
    // Override this
  }

  LoadChildElements(objTree) {
    // Override this
  }

  LoadFromXML(theLoaderObj) {
    this.LoadParameters(theLoaderObj);
    this.LoadSubElements(theLoaderObj);
    this.LoadChildElements(theLoaderObj);
  }
}
